<template>
  <div
    :class="['modal__overlay', customClass]"
    @click="handleOverlayClick"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-title"
  >
    <div class="modal__overlay-content" @click.stop>
      <header class="modal__overlay-content-header">
        <h3 id="modal-title">{{ title }}</h3>
        <button @click="closeModal" aria-label="Close modal" class="modal__overlay-close-cta">
          <svg class="toast__close-icon">
            <use xlink:href="#icon-cross"></use>
          </svg>
        </button>
      </header>
      <div class="modal__overlay-content-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, defineProps, onUnmounted, ref } from 'vue';

  const props = defineProps({
    title: {
      type: String,
      default: '',
    },
    onCloseModal: {
      type: Function,
      default: () => {},
    },
    customClass: {
      type: String,
      default: '',
    },
  });

  onMounted(() => {
    // Prevent body scroll when modal is opened
    document.body.style.overflow = 'hidden';
  });

  onUnmounted(() => {
    document.body.style.overflow = '';
  });

  const closeModal = () => {
    props.onCloseModal();
  };

  // Close the modal when clicking outside of the modal content
  const handleOverlayClick = (event) => {
    // Close the modal only if the overlay (background) is clicked
    if (event.target === event.currentTarget) {
      closeModal();
    }
  };
</script>
